import installablePwaApps from "~/pwa/installablePwaApps.json";

interface InstallableApp {
	description: string;
	icon: string;
	key: string;
	name: string;
	ownedPrefixes: string[];
	shortName: string;
	startUrl: string;
	themeColor: string;
}

const installableApps: InstallableApp[] = installablePwaApps;

export const pathBelongsToApp = (pathname: string, app: InstallableApp): boolean =>
	app.ownedPrefixes.some((prefix) => pathname === prefix || pathname.startsWith(prefix + "/"));

export const findAppForPath = (pathname: string): InstallableApp | null =>
	installableApps.find((app) => pathBelongsToApp(pathname, app)) ?? null;

export const findAppByKey = (key: string | null): InstallableApp | null =>
	installableApps.find((app) => app.key === key) ?? null;

const currentPathname = (): string | null => (typeof window === "undefined" ? null : window.location.pathname);

export const resolveInitialApp = (pathname: string | null = currentPathname()): InstallableApp | null =>
	pathname === null ? null : findAppForPath(pathname);

export const confinementAllowedPrefixes = ["/oauth-redirect", "/Forbidden", "/settings", "/account"];

export const isConfinementAllowedPath = (pathname: string): boolean =>
	confinementAllowedPrefixes.some((prefix) => pathname === prefix || pathname.startsWith(prefix + "/"));

export type { InstallableApp };
export default installableApps;
